import actionTypes from '../../actions/action-types';

export default (state = '', action) => {
  switch (action.type) {
    case actionTypes.SET_SELECTED_LANGUAGE: {
      return action.selectedLanguage;
    }
    default:
      return state;
  }
};





// WEBPACK FOOTER //
// ./src/modules/utils/reducers/selected-language/selected-language.js